<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <div
              class="px-4 pt-5"
            >
              <SimplePageHeader title="Consultants"></SimplePageHeader>
              <v-container fluid class="px-0 pt-2 mt-4">
                <v-row class="hide-on-print">
                  <v-col cols="12" align="right">
                    <ToggleButton
                      :state="collapseButtonState"
                      color="primary"
                      :statesLabel="collapseButtonLabels"
                      @click="(state) => this.collapseButtonState = state === 1 ? 2 : 1 "
                    ></ToggleButton>
                  </v-col>
                </v-row>
                <v-layout column>
                  <v-data-table
                    dense
                    :headers="headers"
                    :items="clientPayrollSummaries"
                    item-key="clientId"
                    :sort-by="['clientName']"
                    :sort-desc="[false]"
                    :expanded="expanded"
                    hide-default-footer
                    show-expand
                    :items-per-page="-1"
                  >
                  <template v-slot:item.totalPaidHours="{ item }">
                    {{ item.totalPaidHours | formatDecimal }}
                  </template>
                  <template v-slot:item.totalPayAmount="{ item }">
                    {{ item.totalPayAmount | currency }}
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td class="py-5" :colspan="headers.length">
                      <v-data-table
                          dense
                          :headers="subHeaders"
                          :items="item.payrollSummaries"
                          class="pb-3 px-5"
                      >
                        <template v-slot:item.payRate="{ item }">
                          {{ item.payRate | currency }} {{ item.payRateTypeId | getPayRateTypeLabel }}
                        </template>
                        <template v-for="hoursCol in hoursColumns" v-slot:[hoursCol.slot]="{ item }">
                          {{ getTypeHours(item, hoursCol.timeTypeId) | formatDecimal }}
                        </template>
                        <template v-for="amountCol in amountColumns" v-slot:[amountCol.slot]="{ item }">
                          {{ getTypeAmount(item, amountCol.timeTypeId) | currency }}
                        </template>
                        <template v-slot:item.totalPaidHours="{ item }">
                          {{ item.totalPaidHours | formatDecimal }}
                        </template>
                        <template v-slot:item.totalContractorCommission="{ item }">
                          {{ item.totalContractorCommission | currency }}
                        </template>
                        <template v-slot:item.totalPay="{ item }">
                          <span :class="{
                            'blue-highlighted' : item.totalPayEdited === true,
                            'yellow-highlighted': item.needsToBeProrated === true
                          }">{{ item.totalPay | currency }}</span>
                          <v-tooltip v-if="item.totalPayEdited === true" bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small color="primary" class="ml-1 hide-on-print" v-bind="attrs" v-on="on">lock</v-icon>
                            </template>
                            <span>Frozen at {{ item.totalPay | currency }}. Typed hours currently compute {{ item.computedTotalPay | currency }}.</span>
                          </v-tooltip>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                class="mx-1 my-1 hide-on-print"
                                color="primary"
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                @click.prevent="handleClickEditHours($event, item)"
                              >
                                <v-icon color="primary">edit</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit hours</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                class="mx-1 my-1 hide-on-print"
                                color="primary"
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                @click.prevent="handleClickViewTimeCard($event, item)"
                              >
                                <v-icon color="primary">schedule</v-icon>
                              </v-btn>
                            </template>
                            <span>Go to time card</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                class="mx-1 my-1 hide-on-print"
                                color="primary"
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                @click="handleClickViewOneOffFees(item)"
                              >
                                <v-icon color="primary">price_check</v-icon>
                              </v-btn>
                            </template>
                            <span>View one off fees</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </td>
                  </template>
                  </v-data-table>
                </v-layout>
              </v-container>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <div
              class="px-4 pt-5"
            >
              <SimplePageHeader title="Internal Employees"></SimplePageHeader>
              <v-container fluid class="px-0 pt-2 mt-4">
                <v-data-table
                  dense
                  :headers="staffHeaders"
                  :items="staffPayrollSummaries"
                >
                  <template v-slot:item.payRate="{ item }">
                    {{ item.payRate | currency }} {{ item.payRateTypeId | getPayRateTypeLabel }}
                  </template>
                  <template v-slot:item.stHours="{ item }">
                    {{ item.stHours | formatDecimal }}
                  </template>
                  <template v-slot:item.totalPay="{ item }">
                    <span :class="{
                      'blue-highlighted' : item.totalPayEdited === true,
                      'yellow-highlighted': item.needsToBeProrated === true
                    }">{{ item.totalPay | currency }}</span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      class="mx-1 my-1 hide-on-print"
                      color="primary"
                      outlined
                      @click="handleClickStaffEditTotalPay(item)"
                    >
                      <v-icon color="primary">edit</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-container>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <OneOffFeesRecordListModal
      :assignmentId="modalAssignmentId"
      :userName="modalUserName"
      :clientName="modalClientName"
      :showDateRangePicker="false"
      :filterDateBegin="filterDateBegin"
      :filterDateEnd="filterDateEnd"
      @closeModal="$emit('OneOffFeeListModalClose')"
      ref="OneOffFeesRecordListModal"
    >
    </OneOffFeesRecordListModal>
    <StaffEditTotalPayModal
      ref="staffEditTotalPayModal"
      :totalPayEditedId="modalTotalPayEditedId"
      :dateBegin="dateBegin"
      :dateEnd="dateEnd"
      :staffId="modalStaffId"
      :employeeName="modalUserName"
      :totalPay="modalTotalPay"
      @editedTotalPay="editedTotalPayHandler"
    >
    </StaffEditTotalPayModal>
  </div>
</template>

<script>
import { ToggleButton } from '@/components/buttons'
import { timeCardReportRoute, timeManagementRoute } from '@/lib/constants/routes'
import { OneOffFeesRecordListModal } from '@/components/oneOffFeesRecords'
import { mapFields } from '@/vueHelpers/vuex'
import { CONSULTANTS } from '@/lib/constants/reportTypes'
import { HOURLY as HOURLY_PAID } from '@/lib/constants/payRateTypes'
import { HOURLY as HOURLY_BILLED } from '@/lib/constants/billRateTypes'
import { SimplePageHeader } from '@/components/pageComponents'
import { getPresentTypeSummaries, getPayrollTypeColumns, getTypeSummaryHours, getTypeSummaryAmount, TypeSummaryAmountField } from '@/lib/reports'
import StaffEditTotalPayModal from './StaffEditTotalPayModal'

export default {
  components: {
    ToggleButton,
    OneOffFeesRecordListModal,
    SimplePageHeader,
    StaffEditTotalPayModal
  },
  props: [
    'clientPayrollSummaries',
    'staffPayrollSummaries',
    'businessEntityId'
  ],
  data () {
    return {
      CONSULTANTS,
      HOURLY_PAID,
      HOURLY_BILLED,
      headers: [
        { text: 'Client', value: 'clientName', sortable: false, cellClass: 'py-3' },
        { text: 'Total Paid Hours', value: 'totalPaidHours', align: 'center', sortable: false },
        { text: 'Total Pay Amount', value: 'totalPayAmount', align: 'center', sortable: false }
      ],
      modalAssignmentId: null,
      modalStaffId: null,
      modalUserName: null,
      modalClientName: null,
      modalTotalPay: null,
      modalTotalPayEditedId: null,
      filterDateBegin: null,
      filterDateEnd: null,
      collapseButtonLabels: {
        1: 'Contract All',
        2: 'Expand All'
      },
      collapseButtonState: 1 // 1 - Expanded, 2 - Collapsed
    }
  },
  computed: {
    ...mapFields('payrollReportFilters',
      [
        'dateBegin',
        'dateEnd',
        'showDetails'
      ]),
    expanded: {
      get () {
        if (this.collapseButtonState === 1) {
          return this.clientPayrollSummaries || []
        } else {
          return []
        }
      }
    },
    staffHeaders () {
      if (!this.showDetails) {
        return [
          { text: 'Internal Employee', value: 'userFullName' },
          { text: 'Pay Amount', value: 'payRate' },
          { text: 'Total Pay', value: 'totalPay' },
          { text: 'Actions', value: 'actions', align: 'center', sortable: false }
        ]
      } else {
        return [
          { text: 'Internal Employee', value: 'userFullName' },
          { text: 'Pay Amount', value: 'payRate' },
          { text: 'Total Hours', value: 'stHours', align: 'center' },
          { text: 'Total Pay', value: 'totalPay' },
          { text: 'Actions', value: 'actions', align: 'center', sortable: false }
        ]
      }
    },
    // Report-wide, not per-row: a type absent from one client's rows still gets its columns if
    // any other row in the report carries it, so a single header array serves every expanded
    // client sub-table.
    presentTypeSummaries () {
      const allSummaries = (this.clientPayrollSummaries || []).flatMap(client => client.payrollSummaries || [])
      return getPresentTypeSummaries(allSummaries)
    },
    typeColumns () {
      return getPayrollTypeColumns(this.presentTypeSummaries, this.showDetails).map(col => ({
        ...col,
        slot: `item.${col.key}`,
        header: { text: col.text, value: col.key, width: '100px', align: 'center' }
      }))
    },
    hoursColumns () {
      return this.typeColumns.filter(col => !col.isAmount)
    },
    amountColumns () {
      return this.typeColumns.filter(col => col.isAmount)
    },
    subHeaders () {
      let headers = []
      if (this.showDetails) {
        headers = [
          { text: 'Consultant', value: 'userFullName', width: '150px' },
          { text: 'Standard Rate', value: 'payRate', width: '150px' },
          ...this.typeColumns.map(col => col.header),
          { text: 'Total Paid Hours', value: 'totalPaidHours', width: '170px' },
          { text: 'Contractor Commission', value: 'totalContractorCommission', width: '170px' },
          { text: 'Total Pay', value: 'totalPay', width: '100px', class: 'px-2', cellClass: 'px-2' },
          { text: 'Actions', value: 'actions', align: 'center', sortable: false, class: 'hide-on-print', cellClass: 'hide-on-print px-0', width: '250px' }
        ]
      } else {
        headers = [
          { text: 'Consultant', value: 'userFullName', width: '19%' },
          { text: 'Standard Rate', value: 'payRate', width: '17%' },
          ...this.typeColumns.map(col => col.header),
          { text: 'Total Paid Hours', value: 'totalPaidHours', width: '19%' },
          { text: 'Total Pay', value: 'totalPay', width: '15%', class: 'px-2', cellClass: 'px-2' },
          { text: 'Actions', value: 'actions', align: 'center', sortable: false, class: 'hide-on-print', cellClass: 'hide-on-print px-0', width: '30%' }
        ]
      }
      return headers
    }
  },
  methods: {
    getTypeHours (item, timeTypeId) {
      return getTypeSummaryHours(item, timeTypeId)
    },
    getTypeAmount (item, timeTypeId) {
      return getTypeSummaryAmount(item, timeTypeId, TypeSummaryAmountField.PAY)
    },
    handleClickViewTimeCard (event, item) {
      let assignmentId = item.id
      let startDate = this.dateBegin
      let endDate = this.dateEnd
      const routeData = this.$router.resolve({
        name: timeCardReportRoute.name,
        query: { startDate: startDate, endDate: endDate, assignmentId: assignmentId }
      })
      if (event.ctrlKey === true) {
        window.open(routeData.href, '_blank')
      } else {
        window.open(routeData.href, '_self')
      }
    },
    handleClickViewOneOffFees (item) {
      this.modalAssignmentId = item.id
      this.modalUserName = item.userFullName
      this.modalClientName = item.clientName
      this.filterDateBegin = item.payrollPeriodDateBegin
      this.filterDateEnd = item.payrollPeriodDateEnd
      this.$refs.OneOffFeesRecordListModal.showModal()
    },
    handleClickEditHours (event, item) {
      const periodEnd = new Date(item.payrollPeriodDateEnd)
      const month = `${periodEnd.getFullYear()}-${String(periodEnd.getMonth() + 1).padStart(2, '0')}`
      const query = { viewMode: 'month', client: item.clientId, consultant: item.userId, assignment: item.id, month: month }
      if (this.businessEntityId > 0) {
        query.businessEntityId = this.businessEntityId
      }
      const routeData = this.$router.resolve({
        name: timeManagementRoute.name,
        query
      })
      if (event.ctrlKey === true) {
        window.open(routeData.href, '_blank')
      } else {
        window.open(routeData.href, '_self')
      }
    },
    handleClickStaffEditTotalPay (item) {
      this.modalTotalPayEditedId = item.totalPayEditedId
      this.modalStaffId = item.id
      this.modalUserName = item.userFullName
      this.modalTotalPay = item.totalPay
      this.$refs.staffEditTotalPayModal.showModal()
    },
    editedTotalPayHandler () {
      this.$emit('editedTotalPay')
    }
  }
}
</script>
